var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 8.95297C9.1488 8.95297 10.08 8.02172 10.08 6.87297C10.08 5.72422 9.1488 4.79297 8.00004 4.79297C6.85129 4.79297 5.92004 5.72422 5.92004 6.87297C5.92004 8.02172 6.85129 8.95297 8.00004 8.95297Z",
    stroke: "#68717B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4133 5.66065C3.72664 -0.112681 12.28 -0.106014 13.5866 5.66732C14.3533 9.05399 12.2466 11.9207 10.4 13.694C9.05997 14.9873 6.93997 14.9873 5.5933 13.694C3.7533 11.9207 1.64664 9.04732 2.4133 5.66065Z",
    stroke: "#68717B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.532c6382b4a10d9b7363e7a61de47cd0.svg";
export { ForwardRef as ReactComponent };